import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { exchangeGoogleCode } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const code = searchParams.get('code');

    if (!code) {
      navigate('/login', { replace: true });
      return;
    }

    (async () => {
      const result = await exchangeGoogleCode(code);
      if (result.success) {
        // Clean URL and redirect
        window.history.replaceState(null, '', '/dashboard');
        navigate('/dashboard', { replace: true });
      } else {
        navigate('/login', { replace: true });
      }
    })();
  }, [navigate, exchangeGoogleCode, searchParams]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#FAF8F5]" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-8 h-8 border-4 border-[#D3735A] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-[#5C5855]">Signing you in...</p>
      </div>
    </div>
  );
}
